import React, { memo } from 'react';

function Play({ color = '#335B70', ...props }) {
    return (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M4.72654 17.5029C5.08095 17.5029 5.38965 17.3704 5.76967 17.1523L15.6337 11.4458C16.3541 11.0206 16.6496 10.7015 16.6496 10.184C16.6496 9.66655 16.3541 9.34747 15.6337 8.93062L5.76967 3.21723C5.38965 2.99759 5.08095 2.87354 4.72654 2.87354C4.04685 2.87354 3.57141 3.38899 3.57141 4.21516V16.1544C3.57141 16.9806 4.04685 17.5029 4.72654 17.5029Z"
                fill={color}
            />
        </svg>
    );
}

export default memo(Play);
